module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Howard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Richard Howard is the pseudonym of a bestselling British author who usually works in another genre. However, his love of the Napoleonic Wars, his life long interest in military history and particularly, the material offered by the campaigns of Napoleon drove him to write the series of novels featuring Alain Lausard and the men who fight alongside him.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14pBu1M/tc-custom/9781788631969.jpg?1725275569613",
      "alt": "This image is the cover for the book Bonaparte's Sons, The Alain Lausard Adventures"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bonaparte's Sons, The Alain Lausard Adventures\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', [_c('b', [_vm._v("In this sweeping historical series debut, a")]), _c('b', [_vm._v(" fallen French aristocrat must prove himself in the furnace of Napoleon’s army.")])]), _c('p', [_c('i', [_vm._v("France, 1795")]), _vm._v(": Confusion and fear reign in the Republic. With her troops facing starvation and annihilation on three fronts, France is killing her patriots. Alain Lausard, an aristocrat whose family were massacred in The Terror, now rots in prison. His one chance at freedom is to serve in the faltering Italian campaign, now commanded by a young Napoleon Bonaparte. ")]), _vm._v(" Trained as a soldier, Lausard commands respect for turning his ragged miscreants into ruthless cavalry. Yet tensions remain. As the unit falls under the command of the despotic Cezar, a hazardous mission behind enemy lines threatens everything . . . \n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Digital Publishing Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0